var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.58854 11.9488C5.26302 12.2662 4.73438 12.2662 4.40885 11.9488L1.07552 8.69883C0.75 8.38145 0.75 7.86602 1.07552 7.54863C1.40104 7.23125 1.92969 7.23125 2.25521 7.54863L4.16667 9.41231V4.875C4.16667 4.42559 4.53906 4.0625 5 4.0625C5.46094 4.0625 5.83333 4.42559 5.83333 4.875V9.41231L7.74479 7.54863C8.07031 7.23125 8.59896 7.23125 8.92448 7.54863C9.25 7.86602 9.25 8.38145 8.92448 8.69883L5.59115 11.9488H5.58854ZM0.833333 2.4375C0.372396 2.4375 0 2.07441 0 1.625C0 1.17559 0.372396 0.8125 0.833333 0.8125H9.16667C9.6276 0.8125 10 1.17559 10 1.625C10 2.07441 9.6276 2.4375 9.16667 2.4375H0.833333Z",
    fill: "#092E3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/Export.193d9e8e4077cd7d0a65db0ee050bb10.svg";
export { ForwardRef as ReactComponent };